module.exports = __webpack_public_path__ + "img/73.bf5ab662.webp";